import type { LastJobInfo } from './types/inventory-sync-types';

/**
 * The only place `lastJobInfo` is parsed. The .NET layer re-serialises the job blob into a JSON string,
 * and can send `null`, an empty string, or — were the DTO ever corrected — an object.
 */
export const parseLastJobInfo = (lastJobInfo: string | LastJobInfo | null | undefined): LastJobInfo | null => {
  if (!lastJobInfo) {
    return null;
  }

  if (typeof lastJobInfo !== 'string') {
    return lastJobInfo;
  }

  try {
    return JSON.parse(lastJobInfo) as LastJobInfo;
  } catch {
    return null;
  }
};
